import { Button } from 'components/Button';
import { ICONS } from 'components/Icon';
import { ModalScreens } from 'components/Navigation/types';
import { useSelector } from 'hooks/useSelector';
import { theme } from 'lib/theme';
import React from 'react';
import { useDispatch } from 'react-redux';
import { NAVIGATE_MODAL } from 'store/actions';
import { selectAppUpdateIsAvailable } from 'store/app/selectors';

export const UpdateAvailableIndicator: React.FC = () => {
  const dispatch = useDispatch();
  const appUpdateIsAvailable = useSelector(selectAppUpdateIsAvailable);

  if (!appUpdateIsAvailable) {
    return null;
  }

  return (
    <Button
      text="Update"
      icon={ICONS.RBPlectrumSolidCutout}
      destructive
      onPress={() =>
        dispatch(
          NAVIGATE_MODAL({
            screen: ModalScreens.UpgradeRequired,
            params: {
              major: appUpdateIsAvailable === 'major',
              withClose: true,
            },
          }),
        )
      }
      style={{ marginTop: 8, marginLeft: theme.paddingHorizontal / 2 }}
    />
  );
};
